<aside id="sidebar_left" class="nano nano-light affix sidebar-default customer-menu" ng-show="!collapseMenuStatus">
    <div class="sidebar-left-content nano-content" tabindex="0">
        <ul class="nav sidebar-menu allMenu">

            <li ng-if="can('sales')" ng-class="{ active: isActive(['dasboard'])}">
                <a href="/dasboard">
                    <i class="icon-orders"></i>
                    <span class="sidebar-title">Dashboard</span>
                </a>
            </li>
            <li ng-if="can('sales')" ng-class="{ active: isActive(['sales-members'])}">
                <a href="/sales-members">
                    <i class="icon-billing"></i>
                    <span class="sidebar-title">Members</span>
                </a>
            </li>
            <li ng-if="can('sales')" ng-class="{ active: isActive(['sales-payments'])}">
                <a href="/sales-payments">
                    <i class="fa fa-money"></i>
                    <span class="sidebar-title">Payments</span>
                </a>
            </li>
            <li ng-if="can('sales')" ng-class="{ active: isActive(['sales-tree'])}">
                <a href="/sales-tree">
                    <i class="fa fa-list"></i>
                    <span class="sidebar-title">Genealogy View</span>
                </a>
            </li>
            <li ng-if="can('sales')" ng-class="{ active: isActive(['sales-feedback'])}">
                <a href="/sales-feedback">
                    <i class="icon-feedback"></i>
                    <span class="sidebar-title">Feedback</span>
                </a>
            </li>
            <li ng-if="can('sales')" ng-class="{ active: isActive(['sales-settings'])}">
                <a href="/sales-settings">
                    <i class="icon-settings"></i>
                    <span class="sidebar-title">Settings</span>
                </a>
            </li>
            <li>
                <a href="#" ng-click="logout()">
                    <i class="icon-logout"></i>
                    <span class="sidebar-title">Log out</span>
                </a>
            </li>
        </ul>
    </div>
</aside>
